<template>
  <router-link to="/">
    <img
      class="img-fluid for-light"
      src="../../assets/images/logo/logo.png"
      alt="ClockSpotter"
    /><img
      class="img-fluid for-dark"
      src="../../assets/images/logo/logo_dark.png"
      alt="ClockSpotter"
    />
    <span class="visually-hidden">ClockSpotter Employer Console</span>
  </router-link>
</template>
<script>

  export default {
    name: 'Logo',
  };
</script>
